import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { P1, P2 } from '@zooplus/ui-components';
import Ellipsis, { EllipsisContainer } from '../Ellipsis/Ellipsis.js';
import MaskedCreditCardNumber from '../MaskedCreditCardNumber/MaskedCreditCardNumber.js';
import styles from './CreditCardInfo.module.scss.js';

const CreditCardInfo = ({ lastFourDigits, expirationMonth, expirationYear, creditCardHolderName, brand, inline }) => {
    const expirationYearLength = expirationYear?.length || 0;
    if (![2, 4].includes(expirationYearLength))
        expirationYear = null;
    else if (expirationYear?.length === 4)
        expirationYear = `${expirationYear}`.substring(2, 4);
    const theme = inline ? 'dark' : 'default';
    return (jsxs("div", { className: classNames(styles.creditCardInfoContainer, { [styles.inline]: inline }), children: [jsxs(EllipsisContainer, { theme: theme, children: [brand && jsx(P1, { className: "preferredPaymentText", children: brand.toLowerCase() }), jsx(MaskedCreditCardNumber, { lastFourDigits: lastFourDigits })] }), jsxs(EllipsisContainer, { theme: theme, children: [creditCardHolderName && jsx(P2, { className: "preferredPaymentText", children: creditCardHolderName }), jsxs("span", { className: styles.expirationContainer, children: [expirationMonth || jsx(Ellipsis, { identifier: "expirationMonth", amount: 2 }), "/", expirationYear || jsx(Ellipsis, { identifier: "expirationYear", amount: 2 })] })] })] }));
};

export { CreditCardInfo as default };
//# sourceMappingURL=CreditCardInfo.js.map
